export default function Subscribe(){
    return(
        <>
            <h6 className="widget-title text-white pb-20 mb-35">Subscribe Now</h6>
            <p>Sign up to receive the latest articles</p>
            <form className="subscribe-form">
                <div className="input-box mail-input mb-10">
                    <input type="text" placeholder="Enter email address" required/>
                </div>

                <button className="theme_btn subscribe-btn">Subscribe Now <i
                        className="fal fa-long-arrow-right"></i></button>
            </form>
        </>
    )
}